/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner } from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';
import {
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSONTyped,
    CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON,
} from './CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner';

/**
 * 
 * @export
 * @interface CreateLeadAdditionalDocumentsRequest
 */
export interface CreateLeadAdditionalDocumentsRequest {
    /**
     * 
     * @type {Array<CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner>}
     * @memberof CreateLeadAdditionalDocumentsRequest
     */
    additional_documents: Array<CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInner>;
}

/**
 * Check if a given object implements the CreateLeadAdditionalDocumentsRequest interface.
 */
export function instanceOfCreateLeadAdditionalDocumentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "additional_documents" in value;

    return isInstance;
}

export function CreateLeadAdditionalDocumentsRequestFromJSON(json: any): CreateLeadAdditionalDocumentsRequest {
    return CreateLeadAdditionalDocumentsRequestFromJSONTyped(json, false);
}

export function CreateLeadAdditionalDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadAdditionalDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'additional_documents': ((json['additional_documents'] as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerFromJSON)),
    };
}

export function CreateLeadAdditionalDocumentsRequestToJSON(value?: CreateLeadAdditionalDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'additional_documents': ((value.additional_documents as Array<any>).map(CreateLeadAdditionalDocumentsRequestAdditionalDocumentsInnerToJSON)),
    };
}

